<script>
import {
    ColumnsDirective, ColumnDirective
} from '@syncfusion/ej2-vue-grids/src/grid/columns.directive';
import { defineAsyncComponent } from "@common/defineAsyncComponent";
/* import {
    ColumnsDirective, ColumnDirective
} from '@syncfusion/ej2-vue-grids/src/grid/columns.directive'; */
import { componentStore } from "@common/componentStore/componentStore";
import { library } from "@common/library/library";
import { configStore } from "@common/configStore";
import { ddStore } from "@common/ddStore";

const controlComponent = defineAsyncComponent(() => import('@common/control/control.vue'));

const configEditorSettings = {
    gridSettings: {
        type: 'OBJECT',
        label: 'Grid Settings',
        id: 'gridSettings',
        default: {
            height: 600,
            paging: true,
            sorting: 'asc',
            grouping: false
        },
        properties: {
            height: {
                type: 'number',
                label: 'Height',
                helpText: 'Height helpText.',
                default: 'Something',
                id: 'height'
            },
            paging: {
                type: 'string',
                label: 'Paging',
                helpText: 'Paging helpText.',
                default: '',
                id: 'paging'
            },
            sorting: {
                type: 'string',
                label: 'Sorting',
                helpText: 'Sorting helpText.',
                default: null,
                id: 'sorting'
            },
            grouping: {
                type: 'string',
                label: 'Grouping',
                helpText: 'Grouping helpText.',
                default: null,
                id: 'grouping'
            }
        }
    },
    tableHeaders: {
        label: 'Table Headers',
        id: 'tableHeaders',
        type: 'ARRAY',
        default: [],
        helpText: 'Headers for the grid.',
        itemConfig: {
            itemType: 'object',
            primaryKey: 'text',
            permissions: {
                canMove: true,
                canDelete: true,
                allowAddItem: true
            },
            keys: {
                text: {
                    type: 'string',
                    default: 'text',
                    id: 'text',
                    label: 'Header Text',
                    helpText: 'help text.'
                },
                field: {
                    type: 'string',
                    default: 'cTitle',
                    id: 'field',
                    label: 'Data Field',
                    helpText: 'help text.'
                },
                width: {
                    type: 'string',
                    default: '500',
                    id: 'width',
                    label: 'Column Width',
                    helpText: 'help text.'
                },
                type: {
                    type: 'string',
                    default: 'string',
                    id: 'type',
                    label: 'Type',
                    helpText: 'Set the type.'
                },
                format: {
                    type: 'string',
                    default: 'Test',
                    id: 'format',
                    label: 'Format',
                    helpText: 'Set the format.'
                },
                columnTemplate: {
                    type: 'string',
                    default: '',
                    id: 'columnTemplate',
                    label: 'Column Template',
                    helpText: 'Provide a custom template for the column data.'
                },
                templateComponents: {
                    type: 'ARRAY',
                    id: 'templateComponents',
                    helpText: 'If you are using components in your template, define them here.',
                    label: 'Template Components',
                    itemConfig: {
                        itemType: 'object',
                        primaryKey: 'htmlTag',
                        permissions: {
                            canMove: true,
                            canDelete: true,
                            allowAddItem: true
                        },
                        keys: {
                            htmlTag: {
                                type: 'dropdown',
                                itemsSource: 'componentStore.getComponentPaths()',
                                fields: {
                                    text: 'htmlTag',
                                    value: 'htmlTag'
                                },
                                default: 'some-component',
                                id: 'htmlTag',
                                label: 'HTML Tag',
                                helpText: 'HTML Tag used to represent the component in your template.'
                            },
                            componentPath: {
                                type: 'dropdown',
                                itemsSource: 'componentStore.getComponentPaths()',
                                fields: {
                                    text: 'text',
                                    value: 'value'
                                },
                                default: '@common/someComponent.vue',
                                id: 'componentPath',
                                label: 'Component Path',
                                helpText: 'The component path relative to root in our code library (see developer).'
                            }
                        },
                        newItem: {
                            htmlTag: 'build-info',
                            componentPath: '@common/buildInfo.vue'
                        }
                    },
                }
            },
            newItem: {
                text: 'Column Label',
                field: '',
                width: '500'
            }
        }
    }
};

let gridConfig = {
    cId: "grid",
    cType: "grid",
    cTitle: "Grid",
    cTemplate: `<div v-if="config" :class="{'isMainGrid': isMainGrid, 'isForProfessions': isForProfessions}" :id="ref + '_wrapper'">
                    <div v-if="summary">
                        <div class="grid-wrapper">
                            <ejs-grid :id="cId"
                                      :dataBound="dataBound"
                                      :rowDataBound="rowDataBound"
                                      :rowSelecting="rowSelecting"
                                      :dataSource="records"
                                      :height="gridSettings.height"
                                      :allowPaging="gridSettings.paging"
                                      :allowSorting="gridSettings.sorting"
                                      :allowGrouping="gridSettings.grouping"
                                      :toolbar="gridSettings.toolbar"
                                      :allowExcelExport="gridSettings.allowExcelExport"
                                      :toolbarClick="toolbarClick"
                                      :pageSettings="config.pageSettings"
                                      :clipMode="gridSettings.clipMode"
                                      :ref="ref">
                                <e-columns>
                                     <e-column v-for="(item, key) in headers"
                                               :key="key" :field="item.field"
                                               :headerText="item.text"
                                               :width="item.width"
                                               :minWidth="item.minWidth"
                                               :maxWidth="item.maxWidth"
                                               :type="item.type || null"
                                               :sortComparer='sortComparer'
                                               :format="item.format || null"></e-column>
                                </e-columns>
                                <e-aggregates>
                                    <e-aggregate>
                                        <e-columns>
                                            <e-column v-for="(item, key) in summary"
                                                      :key="key"
                                                      :type="item.type"
                                                      :field="item.field"
                                                      :customAttributes="item.customAttributes || {}"
                                                      :footerTemplate='footerTemplate(summary, key)'></e-column>
                                        </e-columns>
                                    </e-aggregate>
                                </e-aggregates>
                            </ejs-grid>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="isMainGrid && !reloadingData && !isForProfessions" id="gridControls">
                            <div class="grid-show-all">
                                <control v-if="gridControls['SHOWALL']" :name="'SHOWALL__' + psp" :label="gridControls['SHOWALL']"></control>
                            </div>
                            <div class="grid-settings">
                                <control v-if="gridControls['GRID_SET']" :name="'GRID_SET__' + psp" :label="gridControls['GRID_SET']"></control>
                            </div>
                            <div class="grid-sg-list">
                                <control v-if="gridControls['GRID_SAVED_LIST']" :name="'GRID_SAVED_LIST__' + psp" :placeholder="gridControls['GRID_SAVED_LIST']"
                                :items="grids"
                                :value="selectedGrid"
                                ></control>
                            </div>
                            <div class="grid-filters">
                                <control v-if="gridControls['FILTER-ACTION']" :name="'GRID_SEARCH__' + psp" :label="gridControls['FILTER-ACTION']"></control>
                            </div>
                            <div class="grid-filter-list">
                                <control
                                    v-if="gridControls['FILTER_LIST']"
                                    :name="'GRID_FILTERS_LIST__' + psp"
                                    :placeholder="gridControls['FILTER_LIST']"
                                    :items="filters"
                                    :value="selectedFilter"
                                ></control>
                            </div>
                            <textarea :id="'clipboard__' + psp" :ref="'clipboard__' + psp" :value="clipboardValue"></textarea>
                        </div>
                        <div class="clearfix"></div>
                        <div v-if="psp === 14" id="professionsButtons"></div>
                        <div class="clearfix"></div>
                        <div v-if="isMainGrid && !reloadingData && !isForProfessions">
                            <div class="grid-navigator e-pagertemplatemessage">
                                {{(currentPage - 1) * pageSize + 1}} to {{currentPage * pageSize}} of {{totalRecordsCount}} {{itemsTitle}}
                                <span v-for="(count, tmpPsp) in rowCountAdditional">
                                    | {{count}} of total {{count}} {{pspParentNames(tmpPsp)}}
                                </span>
                            </div>
                            <div v-if="!hidePager" class="grid-navigator control-section">
                                <span>
                                    <span p="title">Page {{currentPage}} of {{totalPages}}</span>
                                    <a class="grid-navigator" href="javascript:void(0)" @click="goToFirstPage()" style="cursor: default;">
                                        <img v-if="currentPage === 1" :src="projectUrl + '/coordinator/xsl/images/sArrowForwardLeftDisabled.gif'" alt="Go to the first page">
                                        <img v-else :src="projectUrl + '/coordinator/xsl/images/sArrowForwardLeft.gif'" alt="Go to the first page">
                                    </a>
                                    <a class="grid-navigator" href="javascript:void(0)" @click="goToPreviousPage()" style="cursor: default;">
                                        <img v-if="currentPage === 1" :src="projectUrl + '/coordinator/xsl/images/sArrowLeftDisabled.gif'" alt="Go to previous page">
                                        <img v-else :src="projectUrl + '/coordinator/xsl/images/sArrowLeft.gif'" alt="Go to previous page">
                                    </a>
                                    <input :ref="'pageInput'" type="text" size="3" aria-label="page number" maxlength="10" class="grid-navigator gridEngineNavigator" @keyup.enter="goToPage" :value="currentPage">
                                    <a class="grid-navigator" href="javascript:void(0)" @click="goToNextPage()" style="cursor: pointer;">
                                        <img v-if="currentPage === totalPages" :src="projectUrl + '/coordinator/xsl/images/sArrowRightDisabled.gif'" alt="Go to next page">
                                        <img v-else :src="projectUrl + '/coordinator/xsl/images/sArrowRight.gif'" alt="Go to next page">
                                    </a>
                                    <a class="grid-navigator" href="javascript:void(0)" @click="goToLastPage()" style="cursor: pointer;">
                                        <img v-if="currentPage === totalPages" :src="projectUrl + '/coordinator/xsl/images/sArrowForwardRightDisabled.gif'" alt="Go to the last page">
                                        <img v-else :src="projectUrl + '/coordinator/xsl/images/sArrowForwardRight.gif'" alt="Go to the last page">
                                    </a>
                                </span>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                        <div :class="{'grid-wrapper': true}" v-if="!preparingData">
                            <ejs-grid :id="cId"
                                      :dataSource="records"
                                      :dataBound="dataBound"
                                      :rowDataBound="rowDataBound"
                                      :rowSelecting="rowSelecting"
                                      :height="gridSettings.height || height"
                                      :rowHeight="gridSettings.rowHeight || 36"
                                      :width="width || 'auto'"
                                      :allowPaging="gridSettings.paging"
                                      :allowSorting="gridSettings.sorting"
                                      :sortSettings="gridSettings.sortSettings"
                                      :allowGrouping="gridSettings.grouping"
                                      :groupSettings='gridSettings.groupSettings'
                                      :allowMultiSorting="true"
                                      :allowFiltering="gridSettings.filtering"
                                      :filterSettings="gridSettings.filterSettings"
                                      :selectionSettings="gridSettings.selectionSettings || {}"
                                      :allowResizing="gridSettings.resizing"
                                      :allowReordering="gridSettings.reordering"
                                      :toolbar="gridSettings.toolbar"
                                      :allowExcelExport="gridSettings.allowExcelExport"
                                      :toolbarClick="toolbarClick"
                                      :rowSelected="rowSelected"
                                      :rowDeselected="rowSelected"
                                      :pageSettings="pageSettings"
                                      :clipMode="gridSettings.clipMode"
                                      :contextMenuItems="ctxMenu"
                                      :contextMenuOpen="contextMenuOpen"
                                      :contextMenuClick="contextMenuClick"
                                      :recordDoubleClick="recordDoubleClick"
                                      :actionBegin="actionBegin"
                                      :resizeStart="resizeStart"
                                      :resizeStop="resizeStop"
                                      :columnDragStart="columnDragStart"
                                      :columnDrop="columnDrop"
                                      :allowRowDragAndDrop="allowRowDragAndDrop"
                                      :rowDropSettings="rowDropSettings"
                                      :rowDrop="rowDrop"
                                      :allowSelection="true"
                                      :showColumnChooser="gridSettings.showColumnChooser"
                                      :beforeOpenColumnChooser="beforeOpenColumnChooser"
                                      :childGrid="gridSettings.childGrid"
                                      :detailDataBound="detailDataBound"
                                      :toolbarTemplate="gridSettings.toolbarTemplate"
                                      :ref="ref">
                                <e-columns>
                                    <e-column v-for="(item, key) in headers"
                                              :key="key" :field="item.field"
                                              :isPrimaryKey="item.isPrimaryKey || false"
                                              :customAttributes="item.customAttributes || {}"
                                              :headerText="item.text"
                                              :width="item.width"
                                              :minWidth="item.minWidth"
                                              :maxWidth="item.maxWidth"
                                              :type="item.type || null"
                                              :format="item.format || null"
                                              :sortComparer='sortComparer'
                                              :showInColumnChooser="typeof item.showInColumnChooser !== 'undefined' ? item.showInColumnChooser : true"
                                              :visible="typeof item.visible !== 'undefined' ? item.visible : true"
                                              :allowSorting="item.allowSorting === false ? false : true"
                                              :filterTemplate="filterTemplates && filterTemplates[item.field]"
                                              :filter="item.filter || gridSettings?.filterSettings?.filter || null"
                                              :template="columnTemplates && columnTemplates[item.field]"></e-column>
                                </e-columns>
                            </ejs-grid>
                        </div>
                    </div>
                </div>`,
    pageSettings: {
        pageSize: 50,
        pageCount: 3
    },
    gridSettings: {
        paging: true,
        sorting: false,
        filtering: false,
        grouping: false
    },
    dsId: {
        type: 'dropdown',
        placeholder: "Select a dataset",
        onchange: "selectDataset",
        filterBarPlaceholder: "Search here",
        popupHeight: "220px",
        allowFiltering: true,
        default: false,
        fields: { text: 'cTitle', value: 'dsId' }
    },
    controls: [
        {
            name: 'SHOWALL',
            type: 'button',
            onclick: 'showAll'
        },
        {
            name: 'GRID_SET',
            type: 'button',
            onclick: 'openGridSettings'
        },
        {
            name: 'GRID_SEARCH',
            type: 'button',
            onclick: 'openFilters'
        },
        {
            name: 'GRID_SAVED_LIST',
            type: 'dropdown',
            onchange: 'gridChange',
            noRecordsTemplate: 'No saved grids found',
            fields: { text: 'text', value: 'value' }
        },
        {
            name: 'GRID_FILTERS_LIST',
            type: 'dropdown',
            onchange: 'filterChange',
            noRecordsTemplate: 'No filters found',
            fields: { text: 'text', value: 'value' }
        }
    ]
};

const generateColumnTemplate = (template) => () => ({
    template: vueApp.component('gridColumnTemplate', {
        template: template,
        components: {
            control: controlComponent
        }
    }),
    data() {
        return { data: {} };
    }
});

let gridCmp = {
    editorSettings: configEditorSettings,
    name: 'grid',
    preInitControls: true,
    props: {
        data: {
            default: []
        },
        settings: {
            default: false
        },
        psp: {
            default: 1
        },
        fromPsp: {
            default: 1
        },
        selectedItems: {
            default: []
        },
        selectedItemsFullData: {
            default: []
        },
        selectedFolder: {
            default: false
        },
        loadFunc: {
            required: false
        },
        ctxClickFnc: {
            default: false
        },
        dblClickFnc: {
            default: false
        },
        changePageFnc: {
            default: false
        },
        resizeStopFnc: {
            default: false
        },
        columnDropFnc: {
            default: false
        },
        searchFnc: {
            default: false
        },
        beforeOpenColumnChooserFnc: {
            default: false
        },
        detailDataBoundFnc: {
            default: false
        },
        columnsVisibilityChangeFnc: {
            default: false
        },
        isList: {
            default: false
        },
        rowBoundFunc: {
            required: false
        },
        rowSelectingFunc: {
            required: false
        }
    },
    data() {
        return {
            records: false,
            summary: false,
            headers: false,
            columnTemplates: {},
            filterTemplates: false,
            tooltipContent: '',
            preparingData: true,
            reloadingData: false,
            width: 'auto',
            height: false,
            filterValue: {},
            initialGridLoad: true,
            ctxMenu: [],
            gridControls: [],
            gridData: [],
            selectedGrid: false,
            selectedFilter: null,
            currentPage: 1,
            totalPages: 0,
            pageSize: 100,
            hidePager: false,
            rowCountAdditional: {},
            totalRecordsCount: 0,
            filters: [],
            grids: [],
            clipboardValue: '',
            leftMenu: [],
            reloadButtons: false,
            columnRemoved: false
        };
    },
    computed: {
        gridSettings() {
            let settings = library.cloneObj(this.settings);
            if ((!settings || library.objIsEmpty(settings)) && this.config && this.config.gridSettings) {
                settings = library.cloneObj(this.config.gridSettings);
            }
            return settings;
        },
        projectUrl() {
            let projectUrl = '/';
            if (typeof PROJECTS_URL !== 'undefined') projectUrl = PROJECTS_URL;
            return projectUrl;
        },
        ref() {
            return this.cId;
        },
        isMainGrid() {
            return !!(this.config && this.gridSettings && this.gridSettings.isMainGrid);
        },
        itemsTitle() {
            return configStore.pspParentNamesPlural[this.psp];
        },
        pageSettings() {
            let settings = library.cloneObj(this.settings);
            let pageSettings = settings && settings.pageSettings ? library.cloneObj(settings.pageSettings) : library.cloneObj(this.config.pageSettings);
            pageSettings.currentPage = this.currentPage;
            if (this.isMainGrid && pageSettings.pageSize !== this.pageSize) {
                pageSettings.pageSize = this.pageSize;
            }
            return pageSettings;
        },
        isForProfessions() {
            return this.fromPsp === 14;
        },
        allowRowDragAndDrop() {
            return (this.config && this.gridSettings && this.gridSettings.allowRowDragAndDrop) || this.psp === 14 || this.fromPsp === 14;
        },
        rowDropSettings() {
            let result = {};
            if (this.allowRowDragAndDrop) {
                if (this.psp === 14) {
                    result = {
                        targetID: 'grid_mainGrid__COORD_PRO_OPP'
                    };
                } else {
                    result = {
                        targetID: 'grid_mainGrid__COORD_PRO'
                    };
                }
            }
            return result;
        },
        gridInfo() {
            let gridInfo = {};
            if (store.state.configStore.cfg.gridSettings
                && store.state.configStore.cfg.gridSettings[this.psp]
                && store.state.configStore.cfg.gridSettings[this.psp][this.selectedGrid]
            ) {
                gridInfo = store.state.configStore.cfg.gridSettings[this.psp][this.selectedGrid];
            }
            return gridInfo;
        }
    },
    watch: {
        'propSelectedFolder': function (newValue, prevValue) {
            if (prevValue === false || newValue === false) return;
            if (!library.isEqualObj(newValue, prevValue)) {
                this.onFolderChange(newValue.DATA_VIEW_ID);
            }
        }
    },
    methods: {
        detailDataBound(e) {
            if (typeof this.detailDataBoundFnc === 'function') this.detailDataBoundFnc(e);
        },
        beforeOpenColumnChooser(e) {
            if (typeof this.beforeOpenColumnChooserFnc === 'function') this.beforeOpenColumnChooserFnc(e);
        },
        dataBound() {
            this.$emit('update:dataBound', true);
        },
        rowDataBound(args) {
            if (typeof this.rowBoundFunc === 'function') this.rowBoundFunc(this, args);
        },
        rowSelecting(args) {
            if (typeof this.rowSelectingFunc === 'function') this.rowSelectingFunc(this, args);
        },
        async onFolderChange(folderID) {
            let gridInfo = library.cloneObj(this.gridInfo);
            if (gridInfo.CLIENT_GRID_SAVED_ID && gridInfo.DATA_VIEW_ID) {
                gridInfo.CLIENT_GRID_SAVED_ID = null;
                delete gridInfo.CLIENT_GRID_SAVED_NAME;
                this.selectedGrid = null;
                this.selectedFilter = null;
            }
            gridInfo.DATA_VIEW_ID = folderID;
            delete gridInfo.DATA_VIEW_NAME;
            library.showLoadingIndicator(this.cId + '_wrapper');
            await configStore.setGridSettings(this.psp, gridInfo);
            library.hideLoadingIndicator(this.cId + '_wrapper');
            this.$nextTick(() => {
                this.getGridData(true);
            });
        },
        pspParentNames(psp) {
            return configStore.pspParentNamesPlural[psp];
        },
        onLoad() {
            if (typeof this.loadFunc === 'function' && !this.isMainGrid) this.loadFunc(this);
            if (this.config && this.gridSettings.heightToContent && this.$parent && this.$parent.$el && this.$parent.$el.parentElement) {
                window.addEventListener('resize', () => {
                    this.resizeHeight();
                }, true);
                this.resizeHeight();
            }
            if (this.isMainGrid) {
                ddStore.preloadGroup('COMMON');
                ddStore.preloadGroup('VOLUNTEER');
                ddStore.preloadGroup('DATA_GRID');
                this.getMainGridData();
            }
        },
        resizeHeight() {
            let minusHeight = this.psp === 14 ? 300 : 160; // NOSONAR
            let tmpHeight = this.$parent.$el.parentElement.clientHeight - minusHeight;
            if (this.config && this.gridSettings.minHeight && tmpHeight < this.gridSettings.minHeight) {
                tmpHeight = this.gridSettings.minHeight;
            }
            this.height = tmpHeight;
        },
        sortComparer(reference, comparer) {
            let tmpReference = library.cloneObj(reference);
            let tmpComparer = library.cloneObj(comparer);
            if (typeof tmpReference === 'object') tmpReference = JSON.stringify(tmpReference);
            if (typeof tmpComparer === 'object') tmpComparer = JSON.stringify(tmpComparer);
            if (tmpReference < tmpComparer) {
                return -1;
            }
            if (tmpReference > tmpComparer) {
                return 1;
            }
            return 0;
        },
        toolbarClick(args) {
            if (args.item.id === this.cId + '_excelexport') {
                if (this.config && this.gridSettings && this.gridSettings.exportFileName) {
                    let excelExportProperties = {
                        fileName: this.gridSettings.exportFileName + '.xlsx'
                    };
                    this.$refs[this.ref].excelExport(excelExportProperties);
                } else {
                    this.$refs[this.ref].excelExport();
                }
            }
        },
        footerTemplate(summary, key) {
            let sumText;
            let sumObj;
            if (Array.isArray(summary[key].data)) {
                sumText = summary[key].data[0];
            } else {
                sumObj = summary[key].data;
            }
            return () => ({
                template: vueApp.component('footerTemplate', {
                    template: `<div>
                                    <div v-if="sumText">
                                        {{sumText}}
                                    </div>
                                    <div v-if="sumObj">
                                        <div v-for="(item, key) in sumObj.VALUES" :key="key">{{key}}: {{item}}</div>
                                        <div v-if="typeof sumObj.WITH_VALUE !== 'undefined'">With value: {{sumObj.WITH_VALUE}}</div>
                                        <div v-if="typeof sumObj.WITHOUT_VALUE !== 'undefined'">Without value: {{sumObj.WITHOUT_VALUE}}</div>
                                    </div>
                               </div>`,
                    data() {
                        return {
                            data: {},
                            sumText: sumText,
                            sumObj: sumObj,
                            key: key
                        };
                    }
                })
            });
        },
        prepareData() {
            this.preparingData = true;
            this.$emit('update:preparingData', true);
            let tmpRecords;
            let tmpSummary;
            let tmpHeaders;
            let getHeadersFromSampleRecord = (iRecords, fromProp) => {
                let iHeaders = [];
                let width = this.gridSettings.width || 'auto';
                if (this.gridSettings.calculateWidth) {
                    width = 10;
                }
                let seachFunction = async () => {
                    if (this.isMainGrid) {
                        this.gridSearch();
                    }
                    if (typeof this.searchFnc === 'function') this.searchFnc(this.filterValue);
                };
                if (this.gridSettings.enableCheckBox) {
                    if (width === 'auto') width = 0;
                    if (this.gridSettings.calculateWidth) {
                        width += 50;
                    }
                    iHeaders.push({
                        field: 'SEARCH',
                        text: '',
                        width: '40px',
                        minWidth: '40px',
                        maxWidth: '40px',
                        type: 'checkbox',
                        showInColumnChooser: false
                    });
                    if (!this.filterTemplates) this.filterTemplates = {};
                    let showFindButton = !this.gridSettings.hideFindButton;
                    let template = library.createTemplateComponent(this.cId + "_filter__template",
                        {
                            template: `<div>
                                            <control name="SEARCH" v-show="showFindButton" :prop-config="controlConfig" :onclick="click"></control>
                                        </div>`,
                            components: {
                                control: controlComponent
                            },
                            data() {
                                return {
                                    data: {},
                                    controlName: 'SEARCH',
                                    controlConfig: {
                                        name: 'SEARCH',
                                        type: 'button',
                                        label: 'Find'
                                    },
                                    showFindButton: showFindButton,
                                    searchFunction: seachFunction
                                };
                            },
                            methods: {
                                click(event) {
                                    seachFunction();
                                }
                            }
                        }, this);
                    this.filterTemplates['SEARCH'] = template;
                }
                if (fromProp) {
                    for (let i in iRecords) {
                        if (i === 'length') continue;
                        if (iRecords[i].width) {
                            if (width === 'auto') width = 0;
                            if (this.gridSettings.calculateWidth) {
                                width += iRecords[i].width;
                            }
                        }
                        if (iRecords[i].columnTemplate) {
                            if (!this.columnTemplates) this.columnTemplates = {};
                            let template = library.createTemplateComponent(this.cId + "_column_" + i + "_template",
                                {
                                    template: '<div @dblclick="dblclick($event)">' + iRecords[i].columnTemplate + '</div>',
                                    components: {
                                        control: controlComponent
                                    },
                                    data() {
                                        return {
                                            data: {}
                                        };
                                    },
                                }, this);
                            this.columnTemplates[iRecords[i].field] = template;
                        }
                        if (iRecords[i].filterTemplate) {
                            if (!this.filterTemplates) this.filterTemplates = {};
                            let controlType = 'string';
                            switch (iRecords[i].type) {
                                case 1:
                                case 201:
                                    controlType = 'number';
                                    break;
                                case 6:
                                case 9:
                                case 203:
                                    controlType = 'date';
                                    break;
                                case 13:
                                    controlType = 'dropdown';
                                    break;
                            }
                            let changeFilter = (controlName, search, search1, option, text) => {
                                let filterValue = library.cloneObj(this.filterValue);
                                if (search instanceof Date) {
                                    let day = search.getDate();
                                    if (day < 10) day = '0' + day;
                                    let month = search.getMonth() + 1;
                                    if (month < 10) month = '0' + month;
                                    let year = search.getFullYear();
                                    search = month + '/' + day + '/' + year;
                                }
                                if (controlType === 'dropdown') {
                                    option = text;
                                }
                                filterValue[controlName] = {
                                    CLIENT_GRID_SEARCH: search || null,
                                    CLIENT_GRID_SEARCH_1: search1 || null,
                                    CLIENT_GRID_SEARCH_OPTION: parseInt(option, 10) || null
                                };
                                this.filterValue = filterValue;
                            };
                            let controlItems = [];
                            if (iRecords[i].items) {
                                controlItems = iRecords[i].items;
                            }
                            let value = iRecords[i].CLIENT_GRID_SEARCH ? iRecords[i].CLIENT_GRID_SEARCH : null;
                            if (controlType === 'dropdown') {
                                for (let i in controlItems) {
                                    if (i === 'length') continue;
                                    if (controlItems[i].text === value) value = controlItems[i].value;
                                }
                            }
                            let secondValue = iRecords[i].CLIENT_GRID_SEARCH_1 ? iRecords[i].CLIENT_GRID_SEARCH_1 : null;
                            let ddValue = iRecords[i].CLIENT_GRID_SEARCH_OPTION ? iRecords[i].CLIENT_GRID_SEARCH_OPTION + '' : '0';
                            this.filterValue[iRecords[i].field] = {
                                CLIENT_GRID_SEARCH: value,
                                CLIENT_GRID_SEARCH_1: secondValue,
                                CLIENT_GRID_SEARCH_OPTION: ddValue
                            };

                            let controlPlaceHolder = iRecords[i].placeholder || '';

                            let template = library.createTemplateComponent(this.cId + "_filter_" + i + "_template",
                                {
                                    template: `
                                                    <div @click="click">
                                                        <div v-if="controlType === 'string'">
                                                            <control :name="controlName" :prop-config="controlConfig" :onchange="onchangeValue" ></control>
                                                        </div>
                                                        <div v-if="controlType === 'number'" class="number-filter">
                                                            <control :name="controlName + '_numberDD'" :prop-config="numberDD" :onchange="onchangeDD" ></control>
                                                            <control :name="controlName" :prop-config="controlConfig" :onchange="onchangeValue" ></control>
                                                            <control v-if="ddValue == 9" :name="controlName + '_numberSecond'" :prop-config="numberSecond" :onchange="onchangeSecond" ></control>
                                                        </div>
                                                        <div v-if="controlType === 'date'" class="date-filter">
                                                            <control :name="controlName + '_dateDD'" :prop-config="dateDD" :onchange="onchangeDD" ></control>
                                                            <control v-if="ddValue < 100" :name="controlName" :prop-config="controlConfig" :onchange="onchangeValue" ></control>
                                                            <control v-if="ddValue == 9" :name="controlName + '_dateSecond'" :prop-config="dateSecond" :onchange="onchangeSecond" ></control>
                                                        </div>
                                                        <div v-if="controlType === 'dropdown'">
                                                            <control :name="controlName" :prop-config="controlConfig" :onchange="onchangeValue" ></control>
                                                        </div>
                                                    </div>`,
                                    components: {
                                        control: controlComponent
                                    },
                                    data() {
                                        return {
                                            data: {},
                                            controlName: iRecords[i].field,
                                            controlType: controlType,
                                            controlConfig: {
                                                name: iRecords[i].field,
                                                type: controlType,
                                                value: value,
                                                fields: { text: 'text', value: 'value' },
                                                items: controlItems,
                                                placeholder: controlPlaceHolder
                                            },
                                            dateSecond: {
                                                type: 'date',
                                                value: secondValue
                                            },
                                            dateDD: {
                                                type: 'dropdown',
                                                showClearButton: false,
                                                value: ddValue,
                                                default: '1',
                                                fields: {
                                                    text: 'text',
                                                    value: 'value'
                                                },
                                                items: [
                                                    {
                                                        text: '=',
                                                        value: 1
                                                    },
                                                    {
                                                        text: '>',
                                                        value: 5
                                                    },
                                                    {
                                                        text: '>=',
                                                        value: 6
                                                    },
                                                    {
                                                        text: '<',
                                                        value: 7
                                                    },
                                                    {
                                                        text: '<=',
                                                        value: 8
                                                    },
                                                    {
                                                        text: 'n-n',
                                                        value: 9
                                                    },
                                                    {
                                                        text: 'yesterday',
                                                        value: 101
                                                    },
                                                    {
                                                        text: 'today',
                                                        value: 102
                                                    },
                                                    {
                                                        text: 'today minus',
                                                        value: 90
                                                    },
                                                    {
                                                        text: 'today plus',
                                                        value: 91
                                                    },
                                                    {
                                                        text: 'today through minus',
                                                        value: 92
                                                    },
                                                    {
                                                        text: 'today through plus',
                                                        value: 93
                                                    },
                                                    {
                                                        text: 'today before minus',
                                                        value: 81
                                                    },
                                                    {
                                                        text: 'today after plus',
                                                        value: 82
                                                    },
                                                    {
                                                        text: 'tomorrow',
                                                        value: 103
                                                    },
                                                    {
                                                        text: 'last week',
                                                        value: 111
                                                    },
                                                    {
                                                        text: 'this week',
                                                        value: 112
                                                    },
                                                    {
                                                        text: 'next week',
                                                        value: 113
                                                    },
                                                    {
                                                        text: 'last month',
                                                        value: 121
                                                    },
                                                    {
                                                        text: 'this month',
                                                        value: 122
                                                    },
                                                    {
                                                        text: 'next month',
                                                        value: 123
                                                    },
                                                    {
                                                        text: 'last quarter',
                                                        value: 131
                                                    },
                                                    {
                                                        text: 'this quarter',
                                                        value: 132
                                                    },
                                                    {
                                                        text: 'next quarter',
                                                        value: 133
                                                    },
                                                    {
                                                        text: 'last year',
                                                        value: 141
                                                    },
                                                    {
                                                        text: 'this year',
                                                        value: 142
                                                    },
                                                    {
                                                        text: 'next year',
                                                        value: 143
                                                    }
                                                ]
                                            },
                                            ddValue: ddValue,
                                            secondValue: secondValue,
                                            value: value,
                                            numberDD: {
                                                type: 'dropdown',
                                                value: ddValue,
                                                showClearButton: false,
                                                default: '1',
                                                fields: {
                                                    text: 'text',
                                                    value: 'value'
                                                },
                                                items: [
                                                    {
                                                        text: '=',
                                                        value: 1
                                                    },
                                                    {
                                                        text: '>',
                                                        value: 3
                                                    },
                                                    {
                                                        text: '>=',
                                                        value: 4
                                                    },
                                                    {
                                                        text: '<',
                                                        value: 5
                                                    },
                                                    {
                                                        text: '<=',
                                                        value: 6
                                                    },
                                                    {
                                                        text: 'n-n',
                                                        value: 7
                                                    },
                                                ]
                                            },
                                            numberSecond: {
                                                type: 'number',
                                                value: secondValue
                                            }
                                        };
                                    },
                                    methods: {
                                        click(event) {
                                            event.stopPropagation();
                                        },
                                        onchange() {
                                            let value = this.value;
                                            let id = false;
                                            if (this.controlType === 'dropdown') {
                                                for (let i in this.controlConfig.items) {
                                                    if (i === 'length') continue;
                                                    if (this.controlConfig.items[i].value === this.value) {
                                                        value = this.controlConfig.items[i].text;
                                                        id = this.controlConfig.items[i].value;
                                                    }
                                                }
                                            }
                                            changeFilter(this.controlName, value, this.secondValue, this.ddValue, id);
                                        },
                                        onchangeValue(event) {
                                            this.value = event.value;
                                            this.onchange();
                                        },
                                        onchangeSecond(event) {
                                            this.secondValue = event.value;
                                            this.onchange();
                                        },
                                        onchangeDD(event) {
                                            this.ddValue = event.value;
                                            this.onchange();
                                        }
                                    }
                                }, this);
                            this.filterTemplates[iRecords[i].field] = template;
                        }
                        iHeaders.push(iRecords[i]);
                    }
                } else {
                    for (let i in iRecords[0]) {
                        if (i === 'length') continue;
                        if (i === 'rowID') continue;
                        iHeaders.push({
                            field: i,
                            text: i,
                            headerText: i
                        });
                    }
                }
                this.width = this.isForProfessions ? '245' : width;
                return iHeaders;
            };
            if (this.config && this.config.tableHeaders) {
                tmpHeaders = [];
                for (let i in this.config.tableHeaders) {
                    if (i === 'length') continue;
                    let tmp = library.cloneObj(this.config.tableHeaders[i]);
                    tmp.headerText = tmp.text;
                    tmpHeaders.push(tmp);
                    if (tmp.columnTemplate) {
                        if (!this.columnTemplates) this.columnTemplates = {};
                        let componentsObj = {};
                        if (tmp.templateComponents) {
                            for (let cmpIndex in tmp.templateComponents) {
                                if (cmpIndex === 'length') continue;
                                let iComponent = tmp.templateComponents[cmpIndex];
                                let filename;
                                let directory;
                                let project;
                                let path = iComponent.componentPath.split('/');
                                filename = path.pop();
                                if (path.length === 2) directory = path.pop(); // NOSONAR
                                project = path.pop();
                                if (project === '@common') {
                                    if (directory) componentsObj[iComponent.htmlTag] = defineAsyncComponent(() => import(`@common/${directory}/${filename}`));
                                    else componentsObj[iComponent.htmlTag] = defineAsyncComponent(() => import(`@common/${filename}`));
                                } else if (project === '@components') {
                                    if (directory) componentsObj[iComponent.htmlTag] = defineAsyncComponent(() => import(`@components/${directory}/${filename}`));
                                    else componentsObj[iComponent.htmlTag] = defineAsyncComponent(() => import(`@components/${filename}`));
                                } else if (project === '@signin') {
                                    if (directory) componentsObj[iComponent.htmlTag] = defineAsyncComponent(() => import(`@signin/${directory}/${filename}`));
                                    else componentsObj[iComponent.htmlTag] = defineAsyncComponent(() => import(`@signin/${filename}`));
                                } else if (project === '@ecDashboard') {
                                    if (directory) componentsObj[iComponent.htmlTag] = defineAsyncComponent(() => import(`@ecDashboard/${directory}/${filename}`));
                                    else componentsObj[iComponent.htmlTag] = defineAsyncComponent(() => import(`@ecDashboard/${filename}`));
                                }
                            }
                        }
                        let template = library.createTemplateComponent(this.cId + "_column_" + i + "_template",
                            {
                                template: '<div @dblclick="dblclick($event)">' + tmp.columnTemplate + '</div>',
                                components: {
                                    control: controlComponent,
                                    ...componentsObj
                                },
                                data() {
                                    return {
                                        data: {}
                                    };
                                },
                            }, this);
                        this.columnTemplates[tmp.field] = template;
                    }
                }
            }
            if ((this.data && this.data.records) || (this.isMainGrid)) {
                tmpRecords = library.cloneObj(this.data.records);
                if (!tmpHeaders) {
                    if (typeof tmpHeaders === 'undefined') tmpHeaders = [];
                    if (this.isMainGrid || typeof this.data.headers !== 'undefined') tmpHeaders = tmpHeaders.concat(getHeadersFromSampleRecord(this.data.headers, true));
                    else tmpHeaders = tmpHeaders.concat(getHeadersFromSampleRecord(tmpRecords));
                }
            }
            if (this.data && this.data.summary) {
                tmpSummary = [];
                for (let i in this.data.summary) {
                    if (i === 'length') continue;
                    let tmp = {};
                    tmp.data = library.cloneObj(this.data.summary[i]);
                    tmp.type = 'custom';
                    tmp.field = i;
                    tmpSummary.push(tmp);
                }
            }
            let grouping = false;
            let groupSettingsColumns = [];
            let sortSettingsColumns = [];
            for (let i in tmpHeaders) {
                if (i === 'length') continue;
                if (tmpHeaders[i].isSortable) {
                    if (tmpHeaders[i].CLIENT_GRID_SORT_GROUP_BY) {
                        grouping = true;
                        groupSettingsColumns[tmpHeaders[i].CLIENT_GRID_SORT_POS - 1] = tmpHeaders[i].field;
                    }
                    sortSettingsColumns[tmpHeaders[i].CLIENT_GRID_SORT_POS - 1] = {
                        direction: tmpHeaders[i].CLIENT_GRID_SORT_DIR ? 'Descending' : 'Ascending', // @todo recheck
                        field: tmpHeaders[i].field
                    };
                }
            }
            if (grouping) {
                this.gridSettings.grouping = true;
                this.gridSettings.groupSettings = { showGroupedColumn: true, showDropArea: false, columns: groupSettingsColumns };
            }
            if (sortSettingsColumns.length) {
                this.gridSettings.sortSettings = { allowUnsort: false, columns: sortSettingsColumns };
            }
            if (!tmpHeaders || library.objIsEmpty(tmpHeaders)) {
                tmpHeaders = [{
                    field: 'NO_RECORDS_TO_DISPLAY',
                    headerText: '',
                    text: ''
                }];
            }
            if (this.gridSettings?.selectionSettings?.persistSelection) {
                if (!tmpHeaders.find((tmp) => tmp.field === 'rowID')) {
                    tmpHeaders.push({
                        field: 'rowID',
                        isPrimaryKey: true,
                        visible: false
                    });
                }
            }
            this.headers = tmpHeaders;
            this.summary = tmpSummary;
            this.records = tmpRecords;
            this.$nextTick(() => {
                this.preparingData = false;
                this.$emit('update:preparingData', false);
            });
        },
        async onPropsUpdate() {
            if (this.isMainGrid) return;
            if (!this.data || (Array.isArray(this.data) && !this.data.length)) {
                this.getDataFromDataset();
            } else {
                if (typeof this.data.records === "undefined") {
                    this.data = {
                        records: library.cloneObj(this.data)
                    };
                } else {
                    let tmpData = {
                        records: library.cloneObj(this.data.records)
                    };
                    if (this.data.headers) {
                        tmpData['headers'] = library.cloneObj(this.data.headers);
                    }
                    if (this.data.summary) {
                        tmpData['summary'] = library.cloneObj(this.data.summary);
                    }
                    this.data = library.cloneObj(tmpData);
                }
                this.prepareData();
            }
        },
        async getDataFromDataset() {
            let config = await componentStore.getConfig(this.cId);
            if (config.dsId && config.dsId !== '0') {
                library.showLoadingIndicator(this.cId + '_wrapper');
                this.sDs.post('sds_getDataset', config.dsId).then((response) => {
                    if (response && response.status === 'success') {
                        let data = [];
                        for (let i in response.data.records) {
                            if (i === 'length') continue;
                            data.push(response.data[i]);
                        }
                        let tmpData = {
                            records: data
                        };
                        if (response.data.summary) {
                            tmpData['summary'] = response.data.summary;
                        }
                        this.data = library.cloneObj(tmpData);
                        this.prepareData();
                    }
                    library.hideLoadingIndicator(this.cId + '_wrapper');
                });
            } else {
                this.prepareData();
            }
        },
        refresh() {
            if (this.$refs && this.$refs[this.ref] && this.$refs[this.ref].ej2Instances) {
                this.$refs[this.ref].ej2Instances.refresh();
            }
        },
        rowSelected() {
            let tmpSelectedRecords = [];
            let tmpSelectedItemsFullData = [];
            if (this.$refs && this.$refs[this.ref] && typeof this.$refs[this.ref].getSelectedRecords === 'function') {
                let selectedRecords = this.$refs[this.ref].getSelectedRecords();
                tmpSelectedItemsFullData = library.cloneObj(selectedRecords);
                for (let i in selectedRecords) {
                    if (i === 'length') continue;
                    tmpSelectedRecords.push(selectedRecords[i].rowID);
                }
            }
            this.selectedItems = tmpSelectedRecords;
            this.selectedItemsFullData = tmpSelectedItemsFullData;
            this.$emit('update:propSelectedItems', tmpSelectedRecords);
            this.$emit('update:propSelectedItemsFullData', tmpSelectedItemsFullData);
        },
        contextMenuOpen(args) {
            if (this.isMainGrid && args.rowInfo && args.rowInfo.target && args.rowInfo.target.classList && (args.rowInfo.target.classList.contains('e-headercelldiv') || args.rowInfo.target.classList.contains('e-content'))) {
                args.cancel = true;
            }
        },
        contextMenuClick(args) {
            if (args && args.rowInfo && args.rowInfo.rowData && args.rowInfo.rowData.rowID) {
                let act = args.item.id.toLowerCase();
                let recordId = args.rowInfo.rowData.rowID;
                if (this.isMainGrid) {
                    let params = {
                        recordId: recordId
                    };
                    if (act === 'clipboard') params.text = args.rowInfo.target.innerText;
                    if (act === 'newlogbook') act = 'new_logbook_lbe';
                    if (act === 'quicklogbook') act = 'addhours';
                    this.doAction(act, params);
                } else if (typeof this.ctxClick === 'function') {
                    this.ctxClick(act, recordId);
                }
            }
        },
        recordDoubleClick(args) {
            if (args && args.rowData && args.rowData.rowID) {
                let recordId = args.rowData.rowID;
                if (this.isMainGrid) {
                    this.doAction('edit', { recordId: recordId });
                }
                if (typeof this.dblClickFnc === 'function') {
                    this.dblClickFnc(recordId, args.rowData);
                }
            }
        },
        async gridSearch(clear) {
            let gridInfo = library.cloneObj(this.gridInfo);
            delete gridInfo.CLIENT_GRID_SAVED_ID;
            delete gridInfo.CLIENT_GRID_SAVED_NAME;
            if (!gridInfo.columns || !gridInfo.columns.length) return;
            let newColumns = library.cloneObj(gridInfo.columns);
            let changed = false;
            let filter = library.cloneObj(this.filterValue);
            if (clear) gridInfo.FILTER_ID = -1;
            this.$nextTick(async () => {
                let tmpColumns = this.$refs[this.ref].getColumns();
                for (let i in newColumns) {
                    if (i === 'length') continue;
                    let fieldName = newColumns[i].GRID_FIELD_NAME;
                    let columnFormGrid = tmpColumns.find((tmpColumn) => tmpColumn.field === fieldName);
                    if (columnFormGrid) {
                        let direction = columnFormGrid.sortDirection === 'Ascending' ? 0 : 1;
                        if (newColumns[i].CLIENT_GRID_SORT_DIR !== direction) {
                            newColumns[i].CLIENT_GRID_SORT_DIR = direction;
                            changed = true;
                        }
                    }
                    if (filter[fieldName]) {
                        if (clear) {
                            if (this.controls && this.controls[fieldName] && this.controls[fieldName].type !== 'dropdown') this.controls[fieldName].value = '';
                            if (this.controls && this.controls[fieldName] && this.controls[fieldName].type === 'dropdown') this.controls[fieldName].value = null;
                            if (this.controls && this.controls[fieldName + '_numberDD']) this.controls[fieldName].value = null;
                            if (this.controls && this.controls[fieldName + '_numberSecond']) this.controls[fieldName].value = '';
                            if (this.controls && this.controls[fieldName + '_dateDD']) this.controls[fieldName].value = null;
                            if (this.controls && this.controls[fieldName + '_dateSecond']) this.controls[fieldName].value = '';
                            if (this.controls && this.controls[fieldName]) this.controls[fieldName].value = '';
                            filter[fieldName].CLIENT_GRID_SEARCH = null;
                            filter[fieldName].CLIENT_GRID_SEARCH_1 = null;
                            filter[fieldName].CLIENT_GRID_SEARCH_OPTION = null;
                        }
                        if (newColumns[i].CLIENT_GRID_SEARCH !== filter[fieldName].CLIENT_GRID_SEARCH) {
                            newColumns[i].CLIENT_GRID_SEARCH = filter[fieldName].CLIENT_GRID_SEARCH;
                            changed = true;
                        }
                        if (newColumns[i].CLIENT_GRID_SEARCH_1 !== filter[fieldName].CLIENT_GRID_SEARCH_1) {
                            newColumns[i].CLIENT_GRID_SEARCH_1 = filter[fieldName].CLIENT_GRID_SEARCH_1;
                            changed = true;
                        }
                        if (newColumns[i].CLIENT_GRID_SEARCH_OPTION !== filter[fieldName].CLIENT_GRID_SEARCH_OPTION) {
                            newColumns[i].CLIENT_GRID_SEARCH_OPTION = parseInt(filter[fieldName].CLIENT_GRID_SEARCH_OPTION, 10);
                            changed = true;
                        }
                    }
                }
                if (changed) {
                    gridInfo.columns = newColumns;
                    if (!this.isList) {
                        library.showLoadingIndicator(this.cId + '_wrapper');
                        await configStore.setGridSettings(this.psp, gridInfo);
                        library.hideLoadingIndicator(this.cId + '_wrapper');
                    }
                    this.getGridData(true);
                }
            });
        },
        processAction(act) {
            switch (act) {
                case 'trapEnter':
                    this.gridSearch();
                    break;
            }
        },
        actionBegin(event) {
            if (event.requestType !== "infiniteScroll" && event.currentPage && this.offset !== event.currentPage) {
                if (this.isMainGrid) {
                    this.currentPage = event.currentPage;
                    this.getGridData();
                }
                if (typeof this.changePage === 'function') {
                    this.config.pageSettings.currentPage = event.currentPage;
                    this.changePage(event.currentPage);
                }
            }
            if (event.requestType === "sorting" && this.isMainGrid) {
                if (event.target.classList.contains('e-sortfilterdiv')) {
                    event.cancel = true;
                    this.doAction('customizeSort', {});
                } else {
                    this.gridSearch();
                }
            }
            if (event.requestType === "columnstate" && typeof this.columnsVisibilityChangeFnc === 'function') {
                this.columnsVisibilityChangeFnc(event);
            }
        },
        resizeStart() {
            this.width = 'auto';
        },
        async resizeStop(event) {
            if (event && event.column && event.column.field && event.column.field !== 'SEARCH' && event.column.width) {
                let width = event.column.width.replace('px', '');
                let columnName = event.column.field;
                if (this.isMainGrid) {
                    let gridInfo = library.cloneObj(this.gridInfo);
                    let changed = false;
                    for (let i in gridInfo.columns) {
                        if (i === 'length') continue;
                        if (gridInfo.columns[i] && gridInfo.columns[i].GRID_FIELD_NAME === columnName) {
                            gridInfo.columns[i].CLIENT_GRID_WIDTH = parseInt(width, 10);
                            changed = true;
                        }
                    }
                    if (changed) {
                        library.showLoadingIndicator(this.cId + '_wrapper');
                        await configStore.setGridSettings(this.psp, gridInfo);
                        library.hideLoadingIndicator(this.cId + '_wrapper');
                    }
                }
                if (typeof this.resizeStopFnc === 'function') this.resizeStopFnc(columnName, width);
            }
        },
        mouseUpListener(e) {
            document.removeEventListener('mouseup', this.mouseUpListener, true);
            setTimeout(async () => {
                if (this.columnRemoved) {
                    let gridInfo = library.cloneObj(this.gridInfo);
                    let tmpColumn = gridInfo.columns.find((elem) => elem.GRID_FIELD_NAME === this.columnRemoved);
                    if (tmpColumn) {
                        if (tmpColumn.MANDATORY) {
                            let title = await ddStore.getAlias('COMMON', 'WARNINGMESSAGE_TITLE');
                            let message = await ddStore.getAlias('DATA_GRID', 'GRIDENGINE_ERR_DETACH_MANDATORY');
                            library.showDialog(message, false, false, { title: title, showAsAlert: true });
                        } else {
                            if (this.$refs && this.$refs[this.ref]) {
                                let tmpColumns = this.$refs[this.ref].getColumns();
                                let order = [];
                                for (let i in tmpColumns) {
                                    if (i === 'length') continue;
                                    if (tmpColumns[i].field && tmpColumns[i].field !== this.columnRemoved) {
                                        order.push(tmpColumns[i].field);
                                    }
                                }
                                if (this.isMainGrid) {
                                    if (!order.length) return;
                                    let gridInfo = library.cloneObj(this.gridInfo);
                                    if (!gridInfo.columns || !gridInfo.columns.length) return;
                                    let newColumns = [];
                                    for (let i in order) {
                                        if (i === 'length') continue;
                                        let tmpColumn = gridInfo.columns.find((elem) => elem.GRID_FIELD_NAME === order[i]);
                                        if (tmpColumn) {
                                            newColumns.push(tmpColumn);
                                        }
                                    }
                                    if (newColumns.length) {
                                        gridInfo.columns = newColumns;
                                        library.showLoadingIndicator(this.cId + '_wrapper');
                                        await configStore.setGridSettings(this.psp, gridInfo);
                                        library.hideLoadingIndicator(this.cId + '_wrapper');
                                        this.getGridData(true);
                                    }
                                }
                            }
                        }
                    }
                }
            }, 500);
        },
        columnDragStart(args) {
            this.columnRemoved = args.column.field;
            document.removeEventListener('mouseup', this.mouseUpListener, true);
            document.addEventListener('mouseup', this.mouseUpListener, true);
        },
        columnDrop() {
            this.columnRemoved = false;
            if (this.$refs && this.$refs[this.ref]) {
                this.$nextTick(async () => {
                    let tmpColumns = this.$refs[this.ref].getColumns();
                    let order = [];
                    for (let i in tmpColumns) {
                        if (i === 'length') continue;
                        if (tmpColumns[i].field) {
                            order.push(tmpColumns[i].field);
                        }
                    }
                    if (this.isMainGrid) {
                        if (!order.length) return;
                        let gridInfo = library.cloneObj(this.gridInfo);
                        if (!gridInfo.columns || !gridInfo.columns.length) return;
                        let newColumns = [];
                        for (let i in order) {
                            if (i === 'length') continue;
                            let tmpColumn = gridInfo.columns.find((elem) => elem.GRID_FIELD_NAME === order[i]);
                            if (tmpColumn) {
                                newColumns.push(tmpColumn);
                            }
                        }
                        if (newColumns.length && !library.isEqualObj(gridInfo.columns, newColumns)) {
                            gridInfo.columns = newColumns;
                            library.showLoadingIndicator(this.cId + '_wrapper');
                            await configStore.setGridSettings(this.psp, gridInfo);
                            library.hideLoadingIndicator(this.cId + '_wrapper');
                        }
                    } else if (typeof this.columnDropFnc === 'function') this.columnDropFnc(order);
                });
            }
        },
        async getMainGridData() {
            if (!this.psp) return;
            library.showLoadingIndicator(this.cId + '_wrapper');
            this.selectedGrid = null;
            this.selectedFilter = null;
            let mainGridData = await this.sDs.post('ec_getMainGridInfo', this.psp, ['gridControls', 'grids', 'filters', 'menuContext']);
            if (mainGridData.data) {
                mainGridData = mainGridData.data;
            } else {
                return;
            }
            if (mainGridData.menuContext) {
                this.prepareCtxMenu(mainGridData.menuContext);
            }
            this.prepareGridControls(mainGridData.gridControls);
            this.prepareGrids(mainGridData.grids);
            this.prepareFilters(mainGridData.filters);
            this.getGridData(true);
            library.hideLoadingIndicator(this.cId + '_wrapper');
        },
        prepareCtxMenu(buttons) {
            let tmpButtons = [];
            for (let i in buttons) {
                if (i === 'length') continue;
                tmpButtons.push({
                    text: buttons[i].title,
                    id: buttons[i].action
                });
            }
            this.$nextTick(() => {
                this.ctxMenu = tmpButtons;
            });
        },
        prepareGridControls(controls) {
            let tmpGridControls = {};
            for (let i in controls) {
                if (i === 'length') continue;
                tmpGridControls[controls[i].name] = controls[i].title || ' ';
            }
            if (!library.isEqualObj(this.gridControls, tmpGridControls)) {
                this.gridControls = tmpGridControls;
            }
        },
        prepareFilters(filters) {
            let tmpFilters = [];
            let selectedFilter = null;
            for (let i in filters) {
                if (i === 'length') continue;
                if (filters[i].selected) {
                    selectedFilter = filters[i].FILTER_ID;
                }
                tmpFilters.push({
                    text: filters[i].FILTER_TITLE,
                    value: filters[i].FILTER_ID
                });
            }
            if (!this.selectedFilter && selectedFilter) {
                this.$nextTick(() => {
                    this.selectedFilter = selectedFilter;
                });
            }
            if (!library.isEqualObj(this.filters, tmpFilters)) {
                this.filters = tmpFilters;
            }
        },
        prepareGrids(grids) {
            let tmpGrids = [];
            let selectedGrid = null;
            for (let i in grids) {
                if (i === 'length') continue;
                if (grids[i].selected) {
                    selectedGrid = grids[i].CLIENT_GRID_SAVED_ID;
                }
                tmpGrids.push({
                    text: grids[i].CLIENT_GRID_SAVED_NAME,
                    value: grids[i].CLIENT_GRID_SAVED_ID
                });
            }
            if (!this.selectedGrid && selectedGrid) {
                this.$nextTick(() => {
                    this.selectedGrid = selectedGrid;
                });
            }
            if (!library.isEqualObj(this.grids, tmpGrids)) {
                this.grids = tmpGrids;
            }
        },
        async getGridData(refresh) {
            // this.reloadingData = true;
            if (refresh) {
                this.loadedPages = [];
                this.records = [];
                this.currentPage = 1;
                this.selectedItems = [];
                this.$emit('update:propSelectedItems', []);
            }
            if (this.loadedPages && this.loadedPages.indexOf(this.currentPage) !== -1) return;
            if (typeof this.loadedPages === 'undefined') this.loadedPages = [];
            this.loadedPages.push(this.currentPage);
            let rowCount = 100; // NOSONAR
            library.showLoadingIndicator(this.cId + '_wrapper');
            await configStore.getGridSettings(this.psp, this.selectedGrid, refresh);
            let gridInfo = library.cloneObj(this.gridInfo);
            if (gridInfo.DATA_VIEW_ID) {
                if (configStore.state.cfg.folders[this.psp]) {
                    let tmpFolder = configStore.state.cfg.folders[this.psp].find((tmp) => tmp.DATA_VIEW_ID === gridInfo.DATA_VIEW_ID);
                    if (tmpFolder) {
                        this.selectedFolder = tmpFolder;
                        this.$emit('update:propSelectedFolder', tmpFolder);
                    }
                }
            }
            if (gridInfo.CLIENT_GRID_SIZE) {
                rowCount = gridInfo.CLIENT_GRID_SIZE;
                this.pageSize = gridInfo.CLIENT_GRID_SIZE;
            }
            let currentOffset = (this.currentPage - 1) * rowCount;
            let params = {
                'offset': currentOffset,
                'rowCount': rowCount,
                'returnRowCount': true,
                'forceHtml': true
            };
            let tmpColumns = [];
            this.data = {};
            if (gridInfo && gridInfo.columns) {
                let tmpGridHeaders = [];
                if (this.isForProfessions && this.psp === 2) {
                    tmpGridHeaders.push({
                        "GRID_FIELD_NAME": "Opportunities",
                        "CLIENT_GRID_WIDTH": '200px',
                        "CLIENT_GRID_SORT_POS": 1,
                        "CLIENT_GRID_SORT_DIR": 0,
                        "CLIENT_GRID_SEARCH": null,
                        "CLIENT_GRID_SEARCH_1": null,
                        "CLIENT_GRID_SEARCH_OPTION": null,
                        "isSortable": 1,
                        "isPossibleSort": 1,
                        "drawTitle": "Opportunities",
                        "MANDATORY": 1,
                        "TYPE": 3,
                        "MULTIPLE": 0,
                        "DEFAULT_WIDTH": '200px',
                        "field": "title",
                        "width": '200px',
                        "headerText": 'Opportunities',
                        "text": 'Opportunities',
                        "columnTemplate": '<div v-html="data[\'title\']"></div>',
                        "filterTemplate": true
                    });
                } else {
                    for (let i in gridInfo.columns) {
                        if (i === 'length') continue;
                        let width = gridInfo.columns[i].CLIENT_GRID_WIDTH ? gridInfo.columns[i].CLIENT_GRID_WIDTH : gridInfo.columns[i].DEFAULT_WIDTH;
                        let gridHeader = library.cloneObj(gridInfo.columns[i]);
                        gridHeader.field = gridInfo.columns[i].GRID_FIELD_NAME;
                        gridHeader.text = gridInfo.columns[i].drawTitle;
                        gridHeader.width = width;
                        gridHeader.headerText = gridInfo.columns[i].drawTitle;
                        gridHeader.type = gridInfo.columns[i].TYPE;
                        gridHeader.placeholder = gridInfo.columns[i].searchPlaceholder || '';
                        gridHeader.CLIENT_GRID_SEARCH_OPTION = gridInfo.columns[i].CLIENT_GRID_SEARCH_OPTION + '';
                        if (gridInfo.columns[i].items) {
                            let tmpItems = [];
                            for (let j in gridInfo.columns[i].items) {
                                if (j === 'length') continue;
                                tmpItems.push({
                                    text: gridInfo.columns[i].items[j].title,
                                    value: gridInfo.columns[i].items[j].id,
                                });
                            }
                            gridHeader.items = tmpItems;
                        }
                        if (gridInfo.columns[i].TYPE === 13 || gridInfo.columns[i].TYPE === 214 || this.isForProfessions) {
                            gridHeader['columnTemplate'] = '<div v-html="data[\'' + gridInfo.columns[i].GRID_FIELD_NAME + '\']"></div>';
                        }
                        gridHeader['filterTemplate'] = true;
                        tmpColumns.push(gridInfo.columns[i].GRID_FIELD_NAME);
                        tmpGridHeaders.push(gridHeader);
                    }
                }
                this.data.headers = tmpGridHeaders;
            }
            let result;
            if (this.isForProfessions) {
                let searchValue = '';
                if (this.filterValue && this.filterValue['title'] && this.filterValue['title'].CLIENT_GRID_SEARCH) {
                    searchValue = this.filterValue['title'].CLIENT_GRID_SEARCH;
                }
                let selectedFolder = this.selectedFolder || 3;
                result = await this.sDs.post('ec_getList', this.psp, searchValue, selectedFolder, null);
            } else {
                result = await this.sDs.post('ec_getCurrentGrid', this.psp, params);
            }
            if (result && result.status === 'success') {
                if (!result.data.records) {
                    result.data.records = [];
                }
                let tmpRow = library.cloneObj(result.data.records[0]);
                for (let i in tmpRow) {
                    if (i === 'length') continue;
                    tmpRow[i] = null;
                }
                let tmpRecords = library.cloneObj(this.records) || [];
                if (result.data.rowCount < tmpRecords.length) {
                    let removeNElements = result.data.rowCount - tmpRecords.length;
                    tmpRecords = tmpRecords.slice(0, removeNElements);
                }
                if (result.data.rowCount) {
                    this.totalRecordsCount = result.data.rowCount;
                    this.totalPages = Math.ceil(this.totalRecordsCount / rowCount);
                    if (result.data.rowCount < rowCount) {
                        this.pageSize = result.data.rowCount;
                        this.hidePager = true;
                    }
                } else {
                    this.hidePager = true;
                }
                if (result.data.rowCountAdditional) {
                    this.rowCountAdditional = result.data.rowCountAdditional;
                }
                for (let i = 0; i < result.data.rowCount; i++) {
                    if (tmpRecords && tmpRecords[i] && tmpRecords[i].loaded) continue;
                    tmpRecords[i] = library.cloneObj(tmpRow);
                }
                let j = 0;
                let tmpIndex = rowCount > result.data.records.length ? result.data.records.length : rowCount;
                for (let i = currentOffset; i < tmpIndex * this.currentPage; i++) {
                    tmpRecords[i] = library.cloneObj(result.data.records[j]);
                    if (typeof tmpRecords[i] === 'object') tmpRecords[i].loaded = true;
                    j++;
                }
                this.data.records = tmpRecords;
            }
            this.prepareData();
            this.reloadingData = false;
            if (typeof this.loadFunc === 'function') this.loadFunc(this);
            this.$nextTick(() => {
                library.hideLoadingIndicator(this.cId + '_wrapper');
            });
        },
        async gridChange(event) {
            if (this.isList) return;
            let selectedGrid = null;
            if (event && event.itemData && event.itemData.value) {
                selectedGrid = event.itemData.value;
            }
            if (this.selectedGrid === selectedGrid) return;
            this.selectedGrid = selectedGrid;
            await configStore.setGridSettings(this.psp, { 'CLIENT_GRID_SAVED_ID': selectedGrid });
            this.getGridData(true);
        },
        async filterChange(event) {
            if (this.isList) return;
            // eslint-disable-next-line no-unreachable
            let selectedFilter = false;
            if (event && event.itemData && event.itemData.value) {
                selectedFilter = event.itemData.value;
            } else if (parseInt(event, 10)) {
                selectedFilter = event;
            }
            if (this.selectedFilter === selectedFilter) return;
            this.selectedFilter = selectedFilter;
            let params = {};
            if (this.gridInfo && this.gridInfo.columns) {
                params.columns = library.cloneObj(this.gridInfo.columns);
            }
            params.FILTER_ID = selectedFilter || -1;
            await configStore.setGridSettings(this.psp, params);
            this.getGridData(true);
        },
        async showAll() {
            await this.gridSearch(true);
            this.$refs[this.ref].clearSelection();
            this.selectedItems = [];
            this.selectedFilter = null;
            this.selectedGrid = null;
            let params = {
                'CLIENT_GRID_SAVED_ID': null,
                'DATA_VIEW_ID': 3
            };
            library.showLoadingIndicator(this.cId + '_wrapper');
            if (this.gridInfo && this.gridInfo.columns) {
                params.columns = library.cloneObj(this.gridInfo.columns);
            }
            await configStore.setGridSettings(this.psp, params);
            library.hideLoadingIndicator(this.cId + '_wrapper');
            this.$nextTick(() => {
                this.$emit('update:propSelectedItems', []);
                this.getGridData(true);
            });
        },
        openGridSettings() {
            this.doAction('customizeGrid');
        },
        openFilters() {
            this.doAction('filter');
        },
        async doAction(act, params) {
            if (!params) params = {};
            params.openInSameWindow = true;
            params.psp = this.psp;
            params.isMainGrid = true;
            params.actVal = act;
            if (act === 'clipboard') {
                this.clipboardValue = params.text;
                this.$nextTick(() => {
                    this.$refs['clipboard__' + this.psp].select();
                    document.execCommand("copy");
                });
                return;
            }
            /* check section */
            if (params.recordId) {
                this.selectedItems = [params.recordId];
            }
            params.recordId = this.selectedItems;
            switch (act) {
                case 'delete':
                    params._this = this;
                    params.functionOnSuccess = (response) => {
                        this.getGridData(true);
                    };
                    break;
                case 'copy':
                    params._this = this;
                    params.functionOnSuccess = (response) => {
                        if (params.recordId.length > 1) {
                            this.getGridData(true);
                        } else {
                            this.doAction('edit', { recordId: response.data[0] });
                        }
                    };
                    break;
            }
            params.doLocalAction = this.doLocalAction;
            let tmpActName = 'open' + library.capitalizeFirstLetter(act);
            let tmpActNameEntity = act + 'Entity';
            /* end popup width section */
            if (act.indexOf('HelpMenu') !== -1) {
                actionStore.openHelpMenu(params);
            } else if (typeof actionStore[tmpActName] === 'function') {
                actionStore[tmpActName](params);
            } else if (typeof actionStore[tmpActNameEntity] === 'function') {
                actionStore[tmpActNameEntity](params);
            } else {
                actionStore.actions.iframeProcessSubmit(act, params, params.width, params.height);
            }
        },
        doLocalAction(refreshPrevWindow, localActionParams, fromPopUpName) {
            let reloadGrid = true;
            if (localActionParams) {
                let params = localActionParams.split(',');
                if (params.length) {
                    switch (params[0]) {
                        case "useFilter":
                            // eslint-disable-next-line no-case-declarations
                            let filterId = parseInt(params[1], 10);
                            if (filterId) {
                                this.filterChange(filterId);
                                reloadGrid = false;
                            }
                            break;
                    }
                }
            }
            if (reloadGrid) {
                this.getGridData(true);
            }
        },
        reloadGrid() {
            this.getMainGridData();
        },
        goToFirstPage() {
            this.$refs[this.ref].goToPage(1);
        },
        goToLastPage() {
            this.$refs[this.ref].goToPage(this.totalPages);
        },
        goToPreviousPage() {
            let prevPage = this.currentPage - 1;
            if (prevPage >= 1) {
                this.$refs[this.ref].goToPage(prevPage);
            }
        },
        goToNextPage() {
            let nextPage = this.currentPage + 1;
            if (nextPage <= this.totalPages) {
                this.$refs[this.ref].goToPage(nextPage);
            }
        },
        goToPage: function () {
            if (this.$refs['pageInput'] && this.$refs['pageInput'].value && parseInt(this.$refs['pageInput'].value, 10)) {
                let page = parseInt(this.$refs['pageInput'].value, 10);
                if (page >= 1 && page !== this.currentPage && page <= this.totalPages) {
                    this.$refs[this.ref].goToPage(page);
                }
            }
        },
        rowDrop: function (args) {
            if (args) {
                args.cancel = true;
                if (args.target
                    && args.target.__vueParentComponent
                    && args.target.__vueParentComponent.ctx
                    && args.target.__vueParentComponent.ctx.component
                    && args.target.__vueParentComponent.ctx.component.$refs
                    && args.target.__vueParentComponent.ctx.component.ref
                    && args.target.__vueParentComponent.ctx.component.$refs[args.target.__vueParentComponent.ctx.component.ref]
                    && typeof args.target.__vueParentComponent.ctx.component.$refs[args.target.__vueParentComponent.ctx.component.ref].getRowInfo === 'function') {
                    let tmpRow = args.target.__vueParentComponent.ctx.component.$refs[args.target.__vueParentComponent.ctx.component.ref].getRowInfo(args.target);
                    let oppIDs = [];
                    let recordsIDs = [];
                    if (this.psp === 14) {
                        for (let i in args.data) {
                            if (i === 'length') continue;
                            recordsIDs.push(args.data[i].rowID);
                        }
                        oppIDs = [tmpRow.rowData.rowID];
                    } else {
                        for (let i in args.data) {
                            if (i === 'length') continue;
                            oppIDs.push(args.data[i].rowID);
                        }
                        recordsIDs = [tmpRow.rowData.rowID];
                    }
                    let params = {
                        oppIDs: oppIDs,
                        recordsIDs: recordsIDs,
                        recordsPsp: 14
                    };
                    actionStore.place(params);
                }
            }
        }
    },
    components: {
        'ejs-grid': defineAsyncComponent(() => import('@common/syncfusion/grid')),
        'e-columns': ColumnsDirective,
        'e-column': ColumnDirective,
        'ejs-tooltip': defineAsyncComponent(() => import('@common/syncfusion/tooltip'))
    }
};

componentStore.initComponent(gridCmp, gridConfig, '@common/grid/grid.vue');
export { gridConfig, gridCmp };
export default gridCmp;
</script>

<style>

.e-grid .e-gridheader .e-sortfilter .e-headercelldiv,
.e-grid .e-gridheader .e-stackedheadercelldiv,
.e-grid .e-gridheader .e-headercell .e-headercelldiv.e-headerchkcelldiv {
    padding: 0 5px 0 5px;
}

.e-grid .e-headercell {
    padding: 0px 5px;
}

.e-grid .e-rowcell {
    padding: 5px 5px;
}

.e-grid .e-sortfilterdiv {
    margin: -15px 5px;
}

/*
.e-grid .e-altrow {
    background: #f9f9f9;
}
*/

.number-filter, .date-filter {
    display: flex;
}

.number-filter > div, .date-filter > div {
    flex-grow: 5;
    margin: 0 3px;
}

[id^=grid_mainGrid] .e-filterbarcell:first-child {
    padding: 0px !important;
}

.e-checkbox-wrapper .e-frame, .e-css.e-checkbox-wrapper .e-frame {
    width: 14px;
    height: 14px;
    line-height: 7px;
    font-size: 7px;
}

/*
.e-row .e-checkbox-wrapper, .e-grid .e-headerchkcelldiv {
    margin: 0 auto !important;
    width: 28px;
    height: 28px;
}
*/

.e-grid .e-checkbox-wrapper {
    margin: 0 auto !important;
    width: 28px;
    height: 20px;
    padding: 0 !important;
}

.e-grid .e-columnheader .e-checkbox-wrapper {
    margin-top: 5px !important;
}

.e-grid .e-headerchkcelldiv {
    margin: -5px !important;
}

.e-grid .e-focused:not(.e-menu-item) {
    box-shadow: unset !important;
}

/*
.e-rowcell.e-gridchkbox, .e-headercell.e-defaultcursor, .e-grid .e-headercell, .e-grid .e-detailheadercell {
    padding: 5px !important;
    padding-left: 16px !important;
}
*/
.e-grid .e-headercell, .e-grid .e-detailheadercell, .e-grid .e-rowcell, .e-grid .e-headerchkcelldiv {
    padding: 0 5px !important;
}

.e-headercell.e-defaultcursor {
    padding-left: 14px !important;
}

.e-input-group-icon.e-date-icon, *.e-control-wrapper .e-input-group-icon.e-date-icon {
    margin-bottom: 2px;
}

.isMainGrid {
    width: 100%;
    height: 100%;
}

.isMainGrid .e-grid, .isMainGrid .e-gridpager, .isMainGrid .e-gridheader {
    border: none !important;
}

.isMainGrid .e-gridpager {
    min-width: 900px;
}

.isMainGrid .e-gridpager > div {
    display: none;
}

.isMainGrid .e-gridpager > div:nth-child(2) {
    display: block;
}

.isMainGrid .grid-navigator.control-section {
    margin-left: 380px;
}

.isMainGrid .grid-sg-list,
.isMainGrid .grid-filter-list {
    width: 540px;
}

.isMainGrid .grid-show-all,
.isMainGrid .grid-filters {
    width: 65px;
}

.isMainGrid .grid-settings {
    width: 90px;
}

.isMainGrid .grid-show-all,
.isMainGrid .grid-settings,
.isMainGrid .grid-sg-list,
.isMainGrid .grid-filters,
.isMainGrid .grid-filter-list {
    display: block;
    float: left;
    margin: 5px;
}

.isMainGrid .e-row {
    background-color: #f9f9f9;
    font-size: 13px;
    font-weight: 400;
}

.isMainGrid .e-row * {
    font-size: 13px;
    font-weight: 400;
}

.isMainGrid .e-altrow {
    background-color: #fff;
}

.isMainGrid .e-row:hover {
    background-color: rgb(254,255,234);
}

.isMainGrid .e-row:hover td {
    background-color: transparent !important;
}

.isMainGrid .e-columnheader  * {
    background-color: #607D8B !important;
    color: #fff;
}

.isMainGrid .e-selectionbackground {
    color: #303030 !important;
    background-color: #e5f7fe !important;
}

.isMainGrid .grid-wrapper {
    margin: 0 5px;
}

.isMainGrid.isForProfessions .grid-wrapper {
    margin: 0 10px;
    border: 1px solid white;
    overflow: hidden;
}

.isForProfessions .e-gridpager {
    display: none;
}

.isMainGrid .e-columnheader .e-frame {
    color: #fff !important;
    border-color: #fff !important;
}

.isForProfessions .e-columnheader .e-frame {
    color: black !important;
    border-color: black !important;
}

.isMainGrid .e-row, .isMainGrid .e-rowcell {
    height: 20px !important;
}

.isMainGrid .e-rowcell,
.isMainGrid .e-filterbarcell {
    border-right: 1px dashed #d6d6d6 !important;
}
.isMainGrid .e-filterbarcell input{
    height: 18px !important;
}

.isMainGrid .e-headercelldiv {
    text-align: center !important;
}

.isMainGrid button {
    font-family: "Open Sans","Helvetica Neue",Helvetica,Arial,sans-serif!important;
    background: #e0e0e0!important;
    color: #303030!important;
    border: 1px solid #bdbdbd!important;
    border-radius: 0!important;
    font-weight: 500!important;
    padding: 3px 5px!important;
    text-align: center!important;
    vertical-align: baseline!important;
    width: auto !important;
    height: 26px !important;
    transition: background-color 0.23s ease-in-out 0s !important;
    box-shadow: none !important;
    font-size: 13px !important;
    margin: 0 auto;
}

.isMainGrid .e-headertext {
    font-size: 13px;
    font-weight: 400 !important;
    color: #fff !important;
    text-decoration: none !important;
}

.isMainGrid input {
    line-height: 14px !important;
    font-size: 13px !important;
    min-height: 14px !important;
}

.isMainGrid #grid-main-content-inner .e-spinner-pane {
    background-color: #5a5a5a;
    opacity: 0.25;
}

.isMainGrid .e-defaultcursor, .isMainGrid .e-rhandler.e-rcursor {
    height: 36px !important
}

.isMainGrid [id^='clipboard__']{
    width: 1px;
    height: 1px;
    position: absolute;
    top: -100px;
}

.isMainGrid .e-grid .e-filterbarcell, .isMainGrid .e-grid .e-filterbarcelldisabled {
    padding-left: 5px !important;
    padding-right: 5px !important;
}

.isMainGrid .e-sortfilterdiv.e-icons {
    color: white !important;
}

.isMainGrid .e-pagertemplatemessage {
    width: 400px;
    float: left;
}
.isMainGrid.isForProfessions .e-pagertemplatemessage {
    width: 290px;
}

.isMainGrid .e-emptyrow {
    visibility: hidden;
}

.isMainGrid .grid-navigator {
    padding-bottom: 0px;
}

.isForProfessions .grid-navigator {
    color: white;
}

.isForProfessions .control-section {
    display: none;
}

.isForProfessions .e-columnheader * {
    background-color: #f2f3f7 !important;
    color: black !important;
}

[id=foldersManager_mainGrid_ACTIONS] {
    color: #007bdb !important;
}

[id=grid_mainGrid__COORD_PRO_OPP] {
    width: 250px!important;
    padding: 0 10px 0 0!important;
}

.proPlace {
   margin-right: 50px;
   align-items: center;
}

.proPlace > * {
    valign: center;
    padding: 3px 15px 5px 0px!important;
}

.proPlace [type="button"] {
    width: 57px!important;
    height: 27px!important;
    border-color: #858585 !important;
    background-color: #E0E0E0 !important;
}

.isMainGrid .e-gridpager {
    display: none;
}

.e-cloneproperties.e-draganddrop {
    z-index: 9999999 !important;
    position: fixed !important;
}
.e-cclist .e-checkbox-wrapper {
    width: 100%;
}
.e-cclist .e-checkbox-wrapper > * {
    display: inline;
}
</style>
